import {Component, OnInit} from '@angular/core';
import {PriceRuleRepository} from '@app/@core/repositories/price-rule.repository';
import {PriceRule} from '@app/models/price-rule';
import {EventLog, EventLogType, IEvent} from '@app/models/v3/event-log';
import {AppService} from '@shared/services/app.service';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {DialogBase} from '@shared/helper/dialog-base';
import {EventLogRepository} from '@app/@core/repositories/be3/event-log.repository';

interface Data {
  priceRule: PriceRule;
}

interface Result {
  action: 'edit';
  priceRule: PriceRule;
}

@Component({
  selector: 'app-price-rule-view',
  templateUrl: './price-rule-view.component.html',
  styles: []
})
export class PriceRuleViewComponent extends DialogBase<Data, Result> implements OnInit {
  priceRule: PriceRule;

  events: IEvent[];

  constructor(ref: DynamicDialogRef, config: DynamicDialogConfig,
              private priceRuleRepository: PriceRuleRepository,
              private eventLogRepository: EventLogRepository,
              private app: AppService
  ) {
    super(ref, config);
  }

  ngOnInit(): void {
    this.priceRule = this.data.priceRule;
    this.priceRuleRepository.get(this.priceRule.id).subscribe(p => {
      this.priceRule = p;
    });

    this.eventLogRepository.search(EventLogType.PRICE_RULE, this.priceRule.id).subscribe(logs => {
      this.events = logs;
    });
  }

  private parseDiffText(text: string) {
    const lines = text.split('\n').filter(line => line.trim().startsWith('- '));
    return lines.map(line => {
      const match = line.match(/- '(.*)' changed: '(.*)' -> '(.*)'/);
      if (match) {
        const [, field, oldValue, newValue] = match;
        return { field, oldValue, newValue };
      }
      return null;
    }).filter(item => item !== null) as { field: string, oldValue: string, newValue: string }[];
  }
}
